<template>
  <div>
    <v-card class="mb-5">
      <v-layout row wrap justify-center>
        <v-flex
          xs12
          sm6
          ma-3
        >
          <survey-run
            :surveyId="survey_id"
            :studentId="student.id"
            externalApp="ENROLLMENTS"
            :externalAppId="enrollment_id"
            :externalAppProcessId="enrollment_status.id"
            v-on:finished="finished"
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-center mt-3>
        <v-btn
          flat
          @click="goToPrevStep"
        >Atrás</v-btn>
        <v-btn
            color="primary"
            @click="goToNextStep"
            :disabled="!canContinue"
        >
            Siguiente
        </v-btn>
      </v-layout>
    </v-card>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import surveyRun from './../surveys/run/run.vue'
  import axios from 'axios'

  export default {
    name: 'enrollment-step-7-survey',
    components: {
      'survey-run': surveyRun,
    },
    props: {
      survey_id: {
        type: Number,
        default: 0
      },
      actualStep: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        canContinue: false
      }
    },
    computed: {
      ...mapGetters({
        enrollment_id: 'currentEnrollmentId',
        enrollment_status: 'currentEnrollment',
        student: 'currentEnrollmentStudent',
      }),
    },
    methods: {
      goToPrevStep() {
        this.$emit('goToPrevStep', 6)
      },
      goToNextStep() {
        this.finishEnrollmentProcess()
        this.$emit('goToNextStep', 8)
      },
      async finishEnrollmentProcess() {
        const { data } = await axios.get(`/api/enrollment/start/finishEnrollmentProcess/${this.enrollment_id}/${this.student.id}`);
        if(data.response) {
          const payload = {
            enrollment_id: this.enrollment_id,
            student_id: this.student.id,
          }
          await this.$store.dispatch('fetchEnrollmentStatus', payload)
          this.$store.dispatch('responseMessage', {
              type: 'success',
              title: this.$t('enrollments.start.finish-enrollment-process-title'),
              text: this.$t('enrollments.start.finish-enrollment-process-text'),
              modal: false
          })
        }
      },
      finished() {
        this.canContinue = true
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step7_survey.vue